import { Footnote, FootnotesState, NumberedFootnote } from './FootnotesReducerTypes';
import { DispatchFunction, AnyAction } from '@owc-utils/SeamlessStore';
import { SeamlessConnection } from '@seamless/store';
import { Reducer } from 'redux';

export type FootnotesDispatchers = {
  addFootnotes: (notes: Footnote[]) => (dispatch: DispatchFunction) => void;
};

const initialState: FootnotesState = {
  footnotes: {},
};

// Reducer connection name
export const connectionName = 'OWC_FOOTNOTES';

// Action const
const ADD_NOTES = `${connectionName}/ADD_NOTES`;

// Actions
/**
 * addFoonotes action will trigger the addition the of the footnote object to the store
 * the footnote object contains the text as well as the number of the footnote
 * @param notes
 */
export const addFootnotes = (notes: Footnote[]) => {
  return (dispatcher: DispatchFunction) => {
    const notesObject: Record<string, NumberedFootnote> = {};
    notes.forEach((noteInitializer, index) => {
      notesObject[noteInitializer.id] = {
        ...noteInitializer,
        number: index + 1,
      };
    });
    dispatcher({
      type: ADD_NOTES,
      payload: {
        footnotes: notesObject,
      },
    });
  };
};
/**
 * create a Footnotes reducer
 */
export const FootnotesReducer: Reducer<FootnotesState> = (
  state = initialState,
  action: AnyAction = { type: '' },
) => {
  switch (action.type) {
    case ADD_NOTES:
      return {
        ...state,
        footnotes: {
          ...state.footnotes,
          ...action.payload.footnotes,
        },
      };
    default:
      return state;
  }
};

export class FootnotesConnection extends SeamlessConnection<FootnotesDispatchers, FootnotesState> {
  constructor() {
    super(connectionName);
  }

  protected getReducer(): Reducer<FootnotesState> {
    return FootnotesReducer;
  }

  public getPublicDispatchers(): FootnotesDispatchers {
    return {
      addFootnotes: (notes: Footnote[]) => addFootnotes(notes),
    };
  }

  protected get initialState(): FootnotesState | undefined {
    return initialState;
  }
}
